// extracted by mini-css-extract-plugin
module.exports = {"header":"inventory_header__2j0VF","itemsCount":"inventory_itemsCount__2zads","infoIcon":"inventory_infoIcon__2LzuQ"};